import type { IStockRepository, TransactionCreateInput } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockTransactionEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createCreateTransactionUseCase({ stockRepository }: Deps) {
  return async function createTransaction(input: TransactionCreateInput): Promise<StockTransactionEntity> {
    return stockRepository.createTransaction(input);
  };
}
